import RoleListPage from "./role-list-page.jsx";

export default RoleListPage;